import { useEffect, useMemo, useState } from "react";
import { routes } from "../../../app/routes";
import { useUrlParams } from "../../../hooks";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const ServiceTypesIndexTopbar = (props: any) => {

  const returnUrl = useUrlParams("returnUrl");
  const id = useUrlParams("id");

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
      {
        label: "Service Types",
        icon: IconDefinitions.hand,
        url: routes.serviceType.index,
        activeMatch: routes.serviceType.index,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
    ],
    [id]
  );

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, id, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems} />;
};

export default ServiceTypesIndexTopbar;

